import React, { useContext, useState } from "react";

import "./style.scss";
// import data from "./data";

import clsx from "clsx";
import { LanguageContext, text } from "../../container/language";
import Patterns from "../../container/Patterns";

const ReferencedTabs = ({ data }) => {
  const { userLanguage } = useContext(LanguageContext);
  const [active, setActive] = useState(0);

  return (
    <div className="tabs js-tabs">
      {data
        .filter((i) => i.tab)
        .map(({ tab: { tabTitle, body = [] } }, idx) => (
          <>
            <div
              className={clsx("tabs__link js-tabs__link", {
                "is-active": active === idx,
              })}
              onClick={() => setActive(idx)}
            >
              <font>
                <font>{text(tabTitle, userLanguage)}</font>
              </font>
            </div>

            <div
              className={clsx("tabs__content js-tabs__content", {
                "is-active": active === idx,
              })}
            >
              <section className="site-block">
                <Patterns data={body} />
              </section>
            </div>
          </>
        ))}
    </div>
  );
};

export default ReferencedTabs;
